(function ($, document, window) {
	'use strict';

	$('.js-product-gallery').each(function () {
		const sliderContainer = $(this);
		const sliderEl = $('.swiper', sliderContainer)[0];

		// https://codepen.io/ABCDEFGHIJ/pen/KKKrddp
		let swiper;
		const breakpoint = window.matchMedia('(min-width:80em)'); // keep track of swiper instances to destroy later
		const breakpointChecker = function breakpointChecker() {
			// if larger viewport and multi-row layout needed
			if (breakpoint.matches === true) {
				// clean up old instances and inline styles when available
				if (swiper !== undefined) swiper.destroy(true, true);
				$('.carousel-nav', sliderContainer).hide();

				return; // else if a small viewport and single column layout needed
			} else if (breakpoint.matches === false) {
				// fire small viewport version of swiper
				$('.carousel-nav', sliderContainer).show();
				return enableSwiper();
			}
		};

		const enableSwiper = function enableSwiper() {
			swiper = new Swiper(sliderEl, {
				hashNavigation: {
                        watchState: true,
                },
                on: {
                    hashSet: function(swiper) {
                        const activeIndex = swiper.activeIndex + 1;
                        $('.product-gallery__thumb-link', sliderContainer).removeClass('active');
                        $('.product-gallery__thumb-link[data-slide-index="' + activeIndex + '"]', sliderContainer).addClass('active');
                    }
                }
			});
		};

		$(function () {
			if (sliderContainer.data('size') === 'small') {
				breakpoint.addListener(breakpointChecker); // kickstart
				breakpointChecker();
			} else {
				enableSwiper();
			}
		});
	});
})(jQuery, document, window);
